import {lazyLoadView} from "@utils/views";

export default {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home.vue')),
    meta: {
        authRequired: false,
        beforeResolve(routeTo, routeFrom, next) {
            return next();
        },
    }
}
